/**
 * DeliveryModule - Root component for the Delivery & Fulfillment module
 *
 * Routes are relative to /delivery
 */

import { Routes, Route } from 'react-router-dom';
import { ROLES } from '../../config/permissions';
import ProtectedRoute from '../../components/ProtectedRoute';

import DeliveryOverview  from './pages/DeliveryOverview';
import DeliveryShipments from './pages/DeliveryShipments';
import DeliveryLabels    from './pages/DeliveryLabels';
import DeliveryTracking  from './pages/DeliveryTracking';

export default function DeliveryModule() {
  return (
    <Routes>
      {/* /delivery → Overview */}
      <Route
        index
        element={
          <ProtectedRoute requiredRole={[ROLES.ADMIN, ROLES.USER]} redirectTo="/delivery">
            <DeliveryOverview />
          </ProtectedRoute>
        }
      />

      {/* /delivery/shipments → Shipments kanban/list */}
      <Route
        path="shipments"
        element={
          <ProtectedRoute requiredRole={[ROLES.ADMIN, ROLES.USER]} redirectTo="/delivery">
            <DeliveryShipments />
          </ProtectedRoute>
        }
      />

      {/* /delivery/labels → Label generator & print queue */}
      <Route
        path="labels"
        element={
          <ProtectedRoute requiredRole={[ROLES.ADMIN, ROLES.USER]} redirectTo="/delivery">
            <DeliveryLabels />
          </ProtectedRoute>
        }
      />

      {/* /delivery/tracking → Live delivery tracking map */}
      <Route
        path="tracking"
        element={
          <ProtectedRoute requiredRole={[ROLES.ADMIN, ROLES.USER]} redirectTo="/delivery">
            <DeliveryTracking />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
